/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import { COLORS } from "./plans.constants";
import { useNavigate } from "react-router-dom";
import { formatNumber } from "utils/formatNumber";
export default function PlanCard({ plan, isArabic }) {
  const navigate = useNavigate();

  return (
    <div className="col-lg-4 col-md-6">
     <div
  className="plan-card p-4 h-100 d-flex flex-column"
  style={{
    background: "rgba(255,255,255,0.05)",
    borderRadius: 15,
    border: "1px solid rgba(255,255,255,0.15)",
    backdropFilter: "blur(10px)",
    boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
    transition: "all 0.3s ease",
    cursor: "pointer",
    color: "#f3e9ff",
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.transform = "translateY(-2px)";
    e.currentTarget.style.background = "rgba(255,255,255,0.08)";
    e.currentTarget.style.borderColor = "#F2B441";
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.transform = "translateY(0)";
    e.currentTarget.style.background = "rgba(255,255,255,0.05)";
    e.currentTarget.style.borderColor = "rgba(255,255,255,0.15)";
  }}
>
        <h5 className="text-center mb-3" style={{ color: COLORS.gold }}>
          {plan.title}
        </h5>

        {plan.desc && (
          <p className="text-center mb-3" style={{ opacity: 0.9 }}>
            {plan.desc}
          </p>
        )}

        <div
          className="text-center mb-4 p-3"
          style={{
            background: "rgba(242,180,65,0.1)",
            borderRadius: 10,
            border: `1px solid ${COLORS.gold}`,
          }}
        >
          <h4 style={{ color: COLORS.gold, margin: 0 }}>
          {formatNumber(Number(plan.price) || 0)} {isArabic ? "د.ع" : "IQD"}
          </h4>
          <small>
  {plan.price === 0
    ? isArabic
      ? "/ أسبوع"
      : "/ week"
    : isArabic
    ? "/ شهر"
    : "/ month"}
</small>
        </div>

        {Array.isArray(plan.notes) && plan.notes.length > 0 && (
          <ul className="list-unstyled flex-grow-1">
            {plan.notes.map((note, i) => (
              <li key={i} className="d-flex gap-2 mb-2">
                <span style={{ color: COLORS.gold }}>✓</span>
                <span>{note}</span>
              </li>
            ))}
          </ul>
        )}

        <button
          style={{
            background: COLORS.gold,
            color: COLORS.darkPurple,
            borderRadius: 12,
            border: "none",
            padding: "14px 0",
            fontWeight: 700,
          }}
          onClick={() => navigate("/signup")}
        >
          {isArabic ? "اشترك الآن" : "Subscribe Now"}
        </button>
      </div>
    </div>
  );
}
